let protocol;
let model;

function setProtocolAndModel(p, m) {
    protocol = p;
    model = m;
}

const MegarevoOrSinexcelColumns = [{
    title: 'SN',
    dataIndex: "SerialNumber",
    width: 160,
    fixed: 'left',
}, {
    title: 'CreateTime',
    dataIndex: 'CreateTime',
    width: 160,
    fixed: 'left',
}, {
    title: 'VAC1Inv(V)',
    dataIndex: 'VAC1Inv',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC1Inv(A)',
    dataIndex: 'IAC1Inv',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'HzAC1Inv(Hz)',
    dataIndex: 'HzAC1Inv',
    width: 160,
    render: (v) => {
        const x = v * 0.01;
        return isNaN(x) ? "" : x.toFixed(2);
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'PAC1Inv(W)',
    dataIndex: 'PAC1Inv',
    width: 160,
}, {
    title: 'VAC2Inv(V)',
    dataIndex: 'VAC2Inv',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC2Inv(A)',
    dataIndex: 'IAC2Inv',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'HzAC2Inv(Hz)',
    dataIndex: 'HzAC2Inv',
    width: 160,
    render: (v) => {
        const x = v * 0.01;
        return isNaN(x) ? "" : x.toFixed(2);
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'PAC2Inv(W)',
    dataIndex: 'PAC2Inv',
    width: 160,
}, {
    title: 'VAC3Inv(V)',
    dataIndex: 'VAC3Inv',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC3Inv(A)',
    dataIndex: 'IAC3Inv',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'HzAC3Inv(Hz)',
    dataIndex: 'HzAC3Inv',
    width: 160,
    render: (v) => {
        const x = v * 0.01;
        return isNaN(x) ? "" : x.toFixed(2);
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'PAC3Inv(W)',
    dataIndex: 'PAC3Inv',
    width: 160,
}, {
    title: 'EDay(kWh)',
    dataIndex: 'EDay',
    width: 160,
    render: (v) => {
        const x = v * 0.001;
        return isNaN(x) ? "" : x.toFixed(3);
    },
    transform: {
        multiplicative_inverse: 1000
    }
}, {
    title: 'ETotal(kWh)',
    dataIndex: 'ETotal',
    width: 160,
    render: (v) => {
        const x = v * 0.001;
        return isNaN(x) ? "" : x.toFixed(3);
    },
    transform: {
        multiplicative_inverse: 1000
    }
}, {
    title: 'EDayToLoad(kWh)',
    dataIndex: 'EDayToLoad',
    width: 160,
    render: (v) => {
        const x = v * 0.001;
        return isNaN(x) ? "" : x.toFixed(3);
    },
    transform: {
        multiplicative_inverse: 1000
    }
}, {
    title: 'ETotalToLoad(kWh)',
    dataIndex: 'ETotalToLoad',
    width: 160,
    render: (v) => {
        const x = v * 0.001;
        return isNaN(x) ? "" : x.toFixed(3);
    },
    transform: {
        multiplicative_inverse: 1000
    }
}, {
    title: 'VMPPT1(V)',
    dataIndex: 'VMPPT1',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IMPPT1(A)',
    dataIndex: 'IMPPT1',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'VMPPT2(V)',
    dataIndex: 'VMPPT2',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IMPPT2(A)',
    dataIndex: 'IMPPT2',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'VMPPT3(V)',
    dataIndex: 'VMPPT3',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IMPPT3(A)',
    dataIndex: 'IMPPT3',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'VMPPT4(V)',
    dataIndex: 'VMPPT4',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IMPPT4(A)',
    dataIndex: 'IMPPT4',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'PMPPT1(W)',
    dataIndex: 'PMPPT1',
    width: 160,
}, {
    title: 'PMPPT2(W)',
    dataIndex: 'PMPPT2',
    width: 160,
}, {
    title: 'PMPPT3(W)',
    dataIndex: 'PMPPT3',
    width: 160,
}, {
    title: 'PMPPT4(W)',
    dataIndex: 'PMPPT4',
    width: 160,
}, {
    title: 'VBat(V)',
    dataIndex: 'VBat',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IBat(A)',
    dataIndex: 'IBat',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'PBat(W)',
    dataIndex: 'PBat',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fffffff) v = (v - 0x100000000);
        return v; 
    },
    transform: {
        signed: 0x7fffffff,
    }
}, {
    title: 'SOC',
    dataIndex: 'SOC',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'BatTemp(°C)',
    dataIndex: 'BatTemp',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'EDayBatChrg(kWh)',
    dataIndex: 'EDayBatChrg',
    width: 160,
    render: (v, r) => {
        if (protocol == 'Sinexcel' && (model == 'EINV125H3-B215' || model == 'EINV125H3-NB172')) {
            let gridToBatRatio = 0.985;
            if(r.ETotalBatChrg > 0 && r.ETotalFromGrid > 0) {
                gridToBatRatio = r.ETotalBatChrg / r.ETotalFromGrid;
            }
            if(r.EDayFromGrid) {
                return (r.EDayFromGrid * 0.001 * gridToBatRatio).toFixed(3);
            } else {
                return '';
            }
        } else {
            return (r.EDayFromGrid * 0.001).toFixed(3);
        }
    }
}, {
    title: 'ETotalBatChrg(kWh)',
    dataIndex: 'ETotalBatChrg',
    width: 160,
    render: (v) => {
        const x = v * 0.001;
        return isNaN(x) ? "" : x.toFixed(3);
    },
    transform: {
        multiplicative_inverse: 1000
    }
}, {
    title: 'EDayBatDischrg(kWh)',
    dataIndex: 'EDayBatDischrg',
    width: 160,
    render: (v, r) => {
        if (protocol == 'Sinexcel' && (model == 'EINV125H3-B215' || model == 'EINV125H3-NB172')) {
            let batToGridRatio = 1.015;
            if(r.ETotalBatDischrg > 0 && r.ETotalToGrid > 0) {
                batToGridRatio = r.ETotalBatDischrg / r.ETotalToGrid;
            }
            if(r.EDayToGrid) {
                return (r.EDayToGrid * 0.001 * batToGridRatio).toFixed(3);
            } else {
                return '';
            }
        } else {
            return (r.EDayToGrid * 0.001).toFixed(3);
        }
    }
}, {
    title: 'ETotalBatDischrg(kWh)',
    dataIndex: 'ETotalBatDischrg',
    width: 160,
    render: (v) => {
        const x = v * 0.001;
        return isNaN(x) ? "" : x.toFixed(3);
    },
    transform: {
        multiplicative_inverse: 1000
    }
}, {
    title: 'BatChargeVoltage(V)',
    dataIndex: 'BatChargeVoltage',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'BatChargeCurrentLimit(A)',
    dataIndex: 'BatChargeCurrentLimit',
    width: 200,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'BatDischargeCurrentLimit(A)',
    dataIndex: 'BatDischargeCurrentLimit',
    width: 200,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'BatCellMaxVoltage(V)',
    dataIndex: 'BatCellMaxVoltage',
    width: 200,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'BatCellMinVoltage(V)',
    dataIndex: 'BatCellMinVoltage',
    width: 200,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'BatCellMaxTemperature(°C)',
    dataIndex: 'BatCellMaxTemperature',
    width: 200,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'BatCellMinTemperature(°C)',
    dataIndex: 'BatCellMinTemperature',
    width: 200,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'EDayEPS(kWh)',
    dataIndex: 'EDayEPS',
    width: 160,
    render: (v) => {
        const x = v * 0.001;
        return isNaN(x) ? "" : x.toFixed(3);
    },
    transform: {
        multiplicative_inverse: 1000
    }
}, {
    title: 'ETotalEPS(kWh)',
    dataIndex: 'ETotalEPS',
    width: 160,
    render: (v) => {
        const x = v * 0.001;
        return isNaN(x) ? "" : x.toFixed(3);
    },
    transform: {
        multiplicative_inverse: 1000
    }
},
{
    title: 'PAC1GEN(W)',
    dataIndex: 'PAC1GEN',
    width: 160,
}, {
    title: 'PAC2GEN(W)',
    dataIndex: 'PAC2GEN',
    width: 160,
}, {
    title: 'PAC3GEN(W)',
    dataIndex: 'PAC3GEN',
    width: 160,
}, {
    title: 'FACGEN(Hz)',
    dataIndex: 'FACGEN',
    width: 160,
    render: (v) => {
        const x = v * 0.01;
        return isNaN(x) ? "" : x.toFixed(2);
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'VAC1GEN(V)',
    dataIndex: 'VAC1GEN',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC1GEN(A)',
    dataIndex: 'IAC1GEN',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'VAC2GEN(V)',
    dataIndex: 'VAC2GEN',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC2GEN(A)',
    dataIndex: 'IAC2GEN',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'VAC3GEN(V)',
    dataIndex: 'VAC3GEN',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC3GEN(A)',
    dataIndex: 'IAC3GEN',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'EDayGEN(kWh)',
    dataIndex: 'EDayGEN',
    width: 160,
    render: (v) => {
        const x = v * 0.001;
        return isNaN(x) ? "" : x.toFixed(3);
    },
    transform: {
        multiplicative_inverse: 1000
    }
}, {
    title: 'PAC1LOAD(W)',
    dataIndex: 'PAC1LOAD',
    width: 160,
}, {
    title: 'PAC2LOAD(W)',
    dataIndex: 'PAC2LOAD',
    width: 160,
}, {
    title: 'PAC3LOAD(W)',
    dataIndex: 'PAC3LOAD',
    width: 160,
}, {
    title: 'VAC1LOAD(V)',
    dataIndex: 'VAC1LOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC1LOAD(A)',
    dataIndex: 'IAC1LOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'VAC2LOAD(V)',
    dataIndex: 'VAC2LOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC2LOAD(A)',
    dataIndex: 'IAC2LOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'VAC3LOAD(V)',
    dataIndex: 'VAC3LOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC3LOAD(A)',
    dataIndex: 'IAC3LOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'EDayLOAD(kWh)',
    dataIndex: 'EDayLOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.001;
        return isNaN(x) ? "" : x.toFixed(3);
    },
    transform: {
        multiplicative_inverse: 1000
    }
}, {
    title: 'ETotalLOAD(kWh)',
    dataIndex: 'ETotalLOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.001;
        return isNaN(x) ? "" : x.toFixed(3);
    },
    transform: {
        multiplicative_inverse: 1000
    }
},
{
    title: 'PAC1GRID(W)',
    dataIndex: 'PAC1GRID',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fffffff) v = (v - 0x100000000);
        return v; 
    },
    transform: {
        signed: 0x7fffffff,
    }
}, {
    title: 'PAC2GRID(W)',
    dataIndex: 'PAC2GRID',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fffffff) v = (v - 0x100000000);
        return v; 
    },
    transform: {
        signed: 0x7fffffff,
    }
}, {
    title: 'PAC3GRID(W)',
    dataIndex: 'PAC3GRID',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fffffff) v = (v - 0x100000000);
        return v; 
    },
    transform: {
        signed: 0x7fffffff,
    }
}, {
    title: 'FACGRID(Hz)',
    dataIndex: 'FACGRID',
    width: 160,
    render: (v) => {
        const x = v * 0.01;
        return isNaN(x) ? "" : x.toFixed(2);
    },
    transform: {
        multiplicative_inverse: 100
    }
}, {
    title: 'VAC1GRID(V)',
    dataIndex: 'VAC1GRID',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC1GRID(A)',
    dataIndex: 'IAC1GRID',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'VAC2GRID(V)',
    dataIndex: 'VAC2GRID',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC2GRID(A)',
    dataIndex: 'IAC2GRID',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'VAC3GRID(V)',
    dataIndex: 'VAC3GRID',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC3GRID(A)',
    dataIndex: 'IAC3GRID',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'EDayToGrid(kWh)',
    dataIndex: 'EDayToGrid',
    width: 160,
    render: (v) => {
        const x = v * 0.001;
        return isNaN(x) ? "" : x.toFixed(3);
    },
    transform: {
        multiplicative_inverse: 1000
    }
}, {
    title: 'ETotalToGrid(kWh)',
    dataIndex: 'ETotalToGrid',
    width: 160,
    render: (v) => {
        const x = v * 0.001;
        return isNaN(x) ? "" : x.toFixed(3);
    },
    transform: {
        multiplicative_inverse: 1000
    }
}, {
    title: 'EDayFromGrid(kWh)',
    dataIndex: 'EDayFromGrid',
    width: 160,
    render: (v) => {
        const x = v * 0.001;
        return isNaN(x) ? "" : x.toFixed(3);
    },
    transform: {
        multiplicative_inverse: 1000
    }
}, {
    title: 'ETotalFromGrid(kWh)',
    dataIndex: 'ETotalFromGrid',
    width: 160,
    render: (v) => {
        const x = v * 0.001;
        return isNaN(x) ? "" : x.toFixed(3);
    },
    transform: {
        multiplicative_inverse: 1000
    }
}, {
    title: 'WarningOrFault01',
    dataIndex: 'WarningOrFault01',
    width: 160,
}, {
    title: 'WarningOrFault02',
    dataIndex: 'WarningOrFault02',
    width: 160,
}, {
    title: 'WarningOrFault03',
    dataIndex: 'WarningOrFault03',
    width: 160,
}, {
    title: 'WarningOrFault04',
    dataIndex: 'WarningOrFault04',
    width: 160,
}, {
    title: 'WarningOrFault05',
    dataIndex: 'WarningOrFault05',
    width: 160,
}, {
    title: 'WarningOrFault06',
    dataIndex: 'WarningOrFault06',
    width: 160,
}, {
    title: 'WarningOrFault07',
    dataIndex: 'WarningOrFault07',
    width: 160,
}, {
    title: 'WarningOrFault08',
    dataIndex: 'WarningOrFault08',
    width: 160,
}, {
    title: 'WarningOrFault09',
    dataIndex: 'WarningOrFault09',
    width: 160,
}, {
    title: 'WarningOrFault10',
    dataIndex: 'WarningOrFault10',
    width: 160,
}, {
    title: 'WarningOrFault11',
    dataIndex: 'WarningOrFault11',
    width: 160,
}, {
    title: 'WarningOrFault12',
    dataIndex: 'WarningOrFault12',
    width: 160,
}, {
    title: 'WarningOrFault13',
    dataIndex: 'WarningOrFault13',
    width: 160,
}, {
    title: 'WarningOrFault14',
    dataIndex: 'WarningOrFault14',
    width: 160,
}, {
    title: 'WarningOrFault15',
    dataIndex: 'WarningOrFault15',
    width: 160,
}, {
    title: 'WarningOrFault16',
    dataIndex: 'WarningOrFault16',
    width: 160,
}];

export {
    setProtocolAndModel,
    MegarevoOrSinexcelColumns
}